import { ligainicial } from "./rutainicial.js";
import { pagesipdus } from "./rutainicial";

const ligabase = ligainicial + "2026/Lic/C";
const ligasipdus = pagesipdus + "2026/Lic/C";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 028
        'numConvocatoria' : 'Convocatoria No. 028/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N65-2026.',
        'vigencia' : '13 al 24 de julio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de CGI de San Felipe Orizatlán; ubicada en la localidad de Huextetitla, Municipio de San Felipe Orizatlán, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }28/N65/N65.rar`,
        'start' : '2026-07-13',
        'end' : '2026-07-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N64-2026.',
        'vigencia' : '13 al 24 de julio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de Espacio de Atención Temporal en Huejutla de Reyes (2a etapa); ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }28/N64/N64.rar`,
        'start' : '2026-07-13',
        'end' : '2026-07-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N63-2026.',
        'vigencia' : '13 al 24 de julio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación del CGI Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }28/N63/N63.rar`,
        'start' : '2026-07-13',
        'end' : '2026-07-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N62-2026.',
        'vigencia' : '13 al 24 de julio de 2026.',
        'descripcionProcedimiento' : 'Terminación de pavimentación de concreto asfáltico en calle Campo de Tiro, colonia San Antonio el Desmonte, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }28/N62/N62.rar`,
        'start' : '2026-07-13',
        'end' : '2026-07-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 027
        'numConvocatoria' : 'Convocatoria No. 027/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N61-2026.',
        'vigencia' : '6 al 17 de julio de 2026.',
        'descripcionProcedimiento' : 'Remodelación de parque en la localidad de Llano Largo, municipio de Huichapan; ubicada en la localidad de Llano Largo, Municipio de Huichapan, Estado de Hidalgo.',
        'urlAnexos' : `${ ligasipdus }27/N61/N61.rar`,
        'start' : '2026-07-06',
        'end' : '2026-07-17',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N60-2026.',
        'vigencia' : '6 al 17 de julio de 2026.',
        'descripcionProcedimiento' : 'Remodelación de parque en la localidad de San José Bojay, municipio de Atitalaquia; ubicada en la localidad de San José Bojay el Grande, Municipio de Atitalaquia, Estado de Hidalgo.',
        'urlAnexos' : `${ ligasipdus }27/N60/N60.rar`,
        'start' : '2026-07-06',
        'end' : '2026-07-17',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N59-2026.',
        'vigencia' : '6 al 17 de julio de 2026.',
        'descripcionProcedimiento' : 'Construcción de Corredor Artesanal y Gastronómico en la Región Otomí - Tepehua, ubicado en la Cabecera Municipal de Huehuetla; ubicada en la localidad y Municipio de Huehuetla, Estado de Hidalgo.',
        'urlAnexos' : `${ ligasipdus }27/N59/N59.rar`,
        'start' : '2026-07-06',
        'end' : '2026-07-17',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N58-2026.',
        'vigencia' : '6 al 17 de julio de 2026.',
        'descripcionProcedimiento' : 'Mejoramiento de imagen urbana en el centro histórico San Agustín Metzquititlán; ubicada en la localidad de Metzquititlán, Municipio de San Agustín Metzquititlán, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }27/N58/N58.rar`,
        'start' : '2026-07-06',
        'end' : '2026-07-17',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 026
        'numConvocatoria' : 'Convocatoria No. 026/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N57-2026.',
        'vigencia' : '29 de junio al 13 de julio de 2026.',
        'descripcionProcedimiento' : 'Sustitución de barreras de concreto en C.E. Autopista Turística de la Montaña, Mineral de la Reforma.; ubicada en la localidad de San Guillermo la Reforma, Municipio de Mineral de la Reforma, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }26/N57/N57.rar`,
        'start' : '2026-06-29',
        'end' : '2026-07-13',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 025
        'numConvocatoria' : 'Convocatoria No. 025/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N56-2026.',
        'vigencia' : '29 de junio al 13 de julio de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Carpintero Colonia Campo de Tiro, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }25/N56/N56.rar`,
        'start' : '2026-06-29',
        'end' : '2026-07-13',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N55-2026.',
        'vigencia' : '29 de junio al 13 de julio de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico, en lateral del boulevard Felipe Ángeles (tramo Perisur - SEPH), en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }25/N55/N55.rar`,
        'start' : '2026-06-29',
        'end' : '2026-07-13',
        'procedimiento' : 'Licitación Pública',
    },
]